// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import api from './advisorApi';
import type {
  RelationshipBulkCreateDTO,
  RelationshipBulkCreateResponseDTO,
} from '../types/bulk';

/**
 * Relationship Bulk Operations API
 *
 * Handles transactional relationship creation with all related entities
 * in a single atomic operation.
 * Note: Backend endpoint remains /profiles/* for API compatibility
 */
export const relationshipBulkApi = {
  /**
   * Create relationship with clients, policies, and signatories in single transaction
   *
   * All-or-nothing semantics: Either everything succeeds or everything is rolled back.
   * Returns comprehensive validation errors if any field fails validation.
   *
   * @param data Complete relationship creation payload
   * @returns Created entities with ID mappings
   * @throws BulkValidationErrorResponse with field-level errors on validation failure
   * @throws ApiError on system errors (all changes rolled back)
   */
  createRelationshipBulk: async (data: RelationshipBulkCreateDTO): Promise<RelationshipBulkCreateResponseDTO> => {
    const response = await api.post<RelationshipBulkCreateResponseDTO>('/profiles/bulk-create', data);
    return response.data;
  },
};

// Backward compatibility alias
export const profileBulkApi = relationshipBulkApi;
